export const PageSettings = {
  log: {
    path: '/log',
    settingObject: 'dx-data-grid-log',
  },
  images: {
    path: '/images',
    settingObject: 'dx-data-grid-material-images',
  },
  newProduct: {
    path: '/general-new-product',
    settingObject: 'dx-data-grid-general-new-product',
  },
  campaigns: {
    path: '/general-campaigns',
    settingObject: 'dx-data-grid-general-campaigns',
  },
  segmentation: {
    path: '/general-segmentation',
    settingObject: 'dx-data-grid-general-segmentation',
  },
  incentives: {
    path: '/general-incentives',
    settingObject: 'dx-data-grid-general-incentives',
  },
  campaignGroups: {
    path: '/general-campaign-groups',
    settingObject: 'dx-data-grid-general-campaign-groups',
  },
  salesPersons: {
    path: '/sales-persons',
    settingObject: 'dx-data-grid-sales-persons',
  },
  salesRoutes: {
    path: '/sales-routes',
    settingObject: 'dx-data-grid-sales-routes',
  },
  b2bCustomerGroups: {
    path: '/b2b-customer-groups',
    settingObject: 'dx-data-grid-b2b-customer-groups',
  },
  b2bCustomers: {
    path: '/b2b-customers',
    settingObject: 'dx-data-grid-b2b-customers',
  },
  b2bUsers: {
    path: '/b2b-users',
    settingObject: 'dx-data-grid-b2b-users',
  },
  b2bRegistrations: {
    path: '/b2b-registrations',
    settingObject: 'dx-data-grid-b2b-registrations',
  },
  incomingInvoices: {
    path: '/incoming-invoices',
    settingObject: 'dx-data-grid-incoming-invoices',
  },
  outgoingInvoices: {
    path: '/outgoing-invoices',
    settingObject: 'dx-data-grid-outgoing-invoices',
  },
  supplierParameters: {
    path: '/supplier-parameters',
    settingObject: 'dx-data-grid-supplier-parameters',
  },
  customerParameters: {
    path: '/customer-parameters',
    settingObject: 'dx-data-grid-customer-parameters',
  },
  einvoiceMailbox: {
    path: '/einvoice-mailbox',
    settingObject: 'dx-data-grid-einvoice-mailbox',
  },
  ediIncomingOrders: {
    path: '/edi-incoming-orders',
    settingObject: 'dx-data-grid-edi-incoming-orders',
  },
  ediOutgoingOrders: {
    path: '/edi-outgoing-orders',
    settingObject: 'dx-data-grid-edi-outgoing-orders',
  },
  themeSettings: {
    path: '/settings-theme',
    settingObject: 'dx-data-grid-settings-theme',
  },
  mailAccounts: {
    path: '/settings-mail-accounts',
    settingObject: 'dx-data-grid-settings-mail-accounts',
  },

  //campaigns

  campaignProducts:{
    path: 'campaigns-products',
    settingObject: 'dx-data-grid-campaigns-products'
  },

  campaignCustomers:{
    path: 'campaigns-customers',
    settingObject: 'dx-data-grid-campaigns-customers'
  },

  campaignProductsSearch:{
    path: 'campaigns-products-search',
    settingObject: 'dx-data-grid-campaigns-products-search'
  },

  campaignCustomersSearch:{
    path: 'campaigns-customers-search',
    settingObject: 'dx-data-grid-campaigns-customers-search'
  },

  //segmentations

  segmentProducts:{
    path: 'segment-products',
    settingObject: 'dx-data-grid-segment-products'
  },

  segmentCustomers:{
    path: 'segment-customers',
    settingObject: 'dx-data-grid-segment-customers'
  },

  segmentBrands:{
    path: 'segment-brands',
    settingObject: 'dx-data-grid-segment-brands'
  },

  segmentProductGroups:{
    path: 'segment-product-groups',
    settingObject: 'dx-data-grid-segment-product-groups'
  },

  segmentProductsSearch:{
    path: 'segment-products-search',
    settingObject: 'dx-data-grid-segment-products-search'
  },

  segmentCustomersSearch:{
    path: 'segment-customers-search',
    settingObject: 'dx-data-grid-segment-customers-search'
  },

  segmentBrandsSearch:{
    path: 'segment-brands-search',
    settingObject: 'dx-data-grid-segment-brands-search'
  },

  segmentProductGroupSearch:{
    path: 'segment-product-groups-search',
    settingObject: 'dx-data-grid-segment-product-groups-search'
  },
  salesmanProductGroup:{
    path: 'salesman-product-group',
    settingObject: 'dx-data-grid-salesman-product-group'
  },
  salesmanProductGroupSearch:{
    path: 'salesman-product-group-search',
    settingObject: 'dx-data-grid-salesman-product-group-search'
  },
  salesSalesmanCustomer:{
    path: 'sales-persons-customer',
    settingObject: 'dx-data-grid-sales-persons-customer'
  },
  salesSalesmanCustomerSearch:{
    path: 'sales-persons-customer-search',
    settingObject: 'dx-data-grid-sales-persons-custome-search'
  },
  //routes
  routeLineList:{
    path: 'segment-route-line-list',
    settingObject: 'dx-data-grid-route-line list'
  },

  routeLineListSearch:{
    path: 'segment-route-line-list-search',
    settingObject: 'dx-data-grid-route-line-list-search'
  },

  //customers
  customerUsersList:{
    path: 'customer-users-list',
    settingObject: 'dx-data-grid-customer-users-list'
  },

  customerUsersListSearch:{
    path: 'customer-users-list-search',
    settingObject: 'dx-data-grid-customer-users-list-search'
  },

  //users
  userCustomersList:{
    path: 'user-customers-list',
    settingObject: 'dx-data-grid-user-customers-list'
  },

  userCustomersListSearch:{
    path: 'user-customers-list-search',
    settingObject: 'dx-data-grid-user-customers-list-search'
  },

  //export-datev
  exportDatevList:{
    path: 'export-datev-list',
    settingObject: 'dx-data-grid-export-datev-list'
  },

  exportDatevPopupList:{
    path: 'export-datev-popup-list',
    settingObject: 'dx-data-grid-export-datev-popup-list'
  },

  transactionsList:{
    path: 'export-bankSlip-transactions-list',
    settingObject: 'dx-data-grid-bankSlip-transactions-list'
  },


  //export intrastat
  exportIntraPopupList:{
    path: 'export-intrastat-popup',
    settingObject: 'dx-data-grid-export-intrastat-popup'
  },

  exportIntraList:{
    path: 'export-intrastat-list',
    settingObject: 'dx-data-grid-export-intrastat-list'
  }
};